"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Modal =
/*#__PURE__*/
function () {
  function Modal(modal, togglers) {
    _classCallCheck(this, Modal);

    this.modal = modal;
    this.container = this.modal.children[0];
    this.togglers = togglers;
    this.closers = _toConsumableArray(this.modal.getElementsByClassName('js-close'));
    this.modalDelay = this.modal ? parseFloat(getComputedStyle(this.modal).transitionDuration.replace('s', '')) * 1000 : 1000;
    this.containerDelay = this.container ? parseFloat(getComputedStyle(this.container).transitionDuration.replace('s', '')) * 1000 : 0;
    this.listen();
  }

  _createClass(Modal, [{
    key: "listen",
    value: function listen() {
      var _this = this;

      this.togglers.forEach(function (toggler) {
        toggler.addEventListener('click', function () {
          _this.open();
        });
      });
      this.closers.forEach(function (closer) {
        closer.addEventListener('click', function () {
          _this.close();
        });
      });
      this.modal.addEventListener('click', function (event) {
        _this.close();
      });
      this.container.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }
  }, {
    key: "open",
    value: function open() {
      var _this2 = this;

      this.modal.style.display = '-webkit-box';
      this.modal.style.display = '-moz-box';
      this.modal.style.display = '-ms-flexbox';
      this.modal.style.display = '-webkit-flex';
      this.modal.style.display = 'flex';
      document.body.classList.add('has-body-fixed');
      setTimeout(function () {
        _this2.modal.classList.add('is-open');
      }, 10);
    }
  }, {
    key: "close",
    value: function close() {
      var _this3 = this;

      this.modal.classList.remove('is-open');
      document.body.classList.remove('has-body-fixed');
      setTimeout(function () {
        _this3.modal.style.display = 'none';
      }, this.modalDelay + this.containerDelay);

      if (this.modal.id == 'welcome-modal') {
        Cookies.set('igd', 'set', {
          expires: 365
        });
      }
    }
  }]);

  return Modal;
}();

document.addEventListener('DOMContentLoaded', function () {
  var modals = _toConsumableArray(document.getElementsByClassName('js-modal'));

  var togglers = _toConsumableArray(document.getElementsByClassName('js-open-modal'));

  if (modals.length) {
    modals.forEach(function (modal, index) {
      if (index == 0 && !Cookies.get('igd')) {
        setTimeout(function () {
          var m = new Modal(modal, togglers.filter(function (toggler) {
            return toggler.dataset.target == modal.id;
          }));
          m.open();
        }, 1000);
      }
    });
  }
});